import { createSlice } from "@reduxjs/toolkit";
import {
  GetStrategy,
  TransactionStatusChange,
  TransactionTable,
  Getwaytransactions,
  AddibkrAssets
} from "../Actions/transactionsService";
import customFailAlert from "../../Alerts/customFailAlert";
import customSuccessAlert from "../../Alerts/customSuccessAlert";
const initialState = {
  error: "",
  code: "",
  status: "",
  loading: false,
  transData: [],
  strategyData: [],
  gateWaylist:[]
};
const transactionReducer = createSlice({
  name: "transaction",
  initialState,
  reducers: {},
  extraReducers: {
    [TransactionTable.pending]: (state, action) => {
      state.loading = true;
    },
    [TransactionTable.fulfilled]: (
      state,
      { payload: { status, data, message, statusCode } }
    ) => {
      state.loading = false;
      if ((statusCode === 200) && data) {
        state.message = message;
        state.status = status;
        state.code = statusCode;
        state.transData = data;
      } else {
        state.transData = [];
        state.error = message;
        state.status = status;
        state.code = statusCode;
      }
    },
    [TransactionTable.rejected]: (state, action) => {
      state.loading = false;
    },


    [TransactionStatusChange.pending]: (state) => {
      state.loading = true;
    },


    [TransactionStatusChange.fulfilled]: (state, { payload }) => {
      state.loading = false;

      const { statusCode, status: payloadStatus, message, data } = payload || {};

      if (
        statusCode === 200
      ) {
        customSuccessAlert(message);
        state.message = message;
        state.status = payloadStatus;
        state.code = statusCode;
      } else {
        customFailAlert(message);
        state.error = message;
        state.status = payloadStatus;
        state.code = statusCode;
      }
    },
    [TransactionStatusChange.rejected]: (state, action) => {
      state.loading = false;
    },




    [GetStrategy.pending]: (state, action) => {
      state.loading = true;
    },
    [GetStrategy.fulfilled]: (
      state,
      { payload: { status, data, message, code } }
    ) => {
      state.loading = false;
      if ((code === 200 || status?.toUpperCase() === "SUCCESS") && data) {
        state.message = message;
        state.status = status;
        state.code = code;
        state.strategyData = data;
      } else {
        state.strategyData = [];
        state.error = message;
        state.status = status;
        state.code = code;
      }
    },
    [GetStrategy.rejected]: (state, action) => {
      state.loading = false;
    },



    [TransactionStatusChange.rejected]: (state, action) => {
      state.loading = false;
    },

    
    [Getwaytransactions.pending]: (state, action) => {
      state.loading = true;
    },
    [Getwaytransactions.fulfilled]: (
      state,
      { payload: { status, data, message, code } }
    ) => {
      state.loading = false;
      if ((code === 200 || status?.toUpperCase() === "SUCCESS") && data) {
        state.message = message;
        state.status = status;
        state.code = code;
        state.gateWaylist = data;
      } else {
        state.gateWaylist = [];
        state.error = message;
        state.status = status;
        state.code = code;
      }
    },
    [Getwaytransactions.rejected]: (state, action) => {
      state.loading = false;
    },


    [AddibkrAssets.pending]: (state, action) => {
      state.loading = true;
    },
    [AddibkrAssets.fulfilled]: (
      state,
      { payload: { status, data, message, statusCode } }
    ) => {
      state.loading = false;
      if (statusCode === 200) {
        state.message = message;
        state.status = status;
        state.code = statusCode;
      } else {
        state.gateWaylist = [];
        state.error = message;
        state.status = status;
        state.code = statusCode;
      }
    },
    [AddibkrAssets.rejected]: (state, action) => {
      state.loading = false;
    },

  },
});

export default transactionReducer.reducer;
